import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'medrecord-back-icon-button',
  templateUrl: './back-icon-button.component.html',
  styleUrls: ['./back-icon-button.component.scss']
})
export class BackIconButtonComponent {

  @Input() tooltip = 'common_back';

  constructor(private location: Location) {}

  goBack(): void {
    this.location.back();
  }

}
